import { request } from './repository';

const url = 'service-groups/';

const servicesGroupsRepository = {
    fetchServicesGroup(data) {
        return request.get(url + data.group_id)
    },
    storeServicesGroup(data) {
        return request.post(url, data)
    },
}

export default servicesGroupsRepository;